var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_19984",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_19984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 22C12.2998 22 11.9859 21.8694 11.7248 21.6083C11.4637 21.3472 11.3332 21.0333 11.3332 20.6667V12C11.1443 12 10.9859 11.9361 10.8582 11.8083C10.7304 11.6806 10.6665 11.5222 10.6665 11.3333C10.6665 11.1444 10.7304 10.9861 10.8582 10.8583C10.9859 10.7306 11.1443 10.6667 11.3332 10.6667H13.9998C13.9998 10.4778 14.0637 10.3194 14.1915 10.1917C14.3193 10.0639 14.4776 10 14.6665 10H17.3332C17.5221 10 17.6804 10.0639 17.8082 10.1917C17.9359 10.3194 17.9998 10.4778 17.9998 10.6667H20.6665C20.8554 10.6667 21.0137 10.7306 21.1415 10.8583C21.2693 10.9861 21.3332 11.1444 21.3332 11.3333C21.3332 11.5222 21.2693 11.6806 21.1415 11.8083C21.0137 11.9361 20.8554 12 20.6665 12V20.6667C20.6665 21.0333 20.5359 21.3472 20.2748 21.6083C20.0137 21.8694 19.6998 22 19.3332 22H12.6665ZM19.3332 12H12.6665V20.6667H19.3332V12ZM15.3332 15.9V18C15.3332 18.1889 15.3971 18.3472 15.5248 18.475C15.6526 18.6028 15.8109 18.6667 15.9998 18.6667C16.1887 18.6667 16.3471 18.6028 16.4748 18.475C16.6026 18.3472 16.6665 18.1889 16.6665 18V15.9L17.2665 16.4833C17.3887 16.6056 17.5415 16.6667 17.7248 16.6667C17.9082 16.6667 18.0665 16.6 18.1998 16.4667C18.3221 16.3444 18.3832 16.1889 18.3832 16C18.3832 15.8111 18.3221 15.6556 18.1998 15.5333L16.4665 13.8C16.3332 13.6667 16.1776 13.6 15.9998 13.6C15.8221 13.6 15.6665 13.6667 15.5332 13.8L13.7998 15.5333C13.6776 15.6556 13.6137 15.8083 13.6082 15.9917C13.6026 16.175 13.6665 16.3333 13.7998 16.4667C13.9221 16.5889 14.0748 16.6528 14.2582 16.6583C14.4415 16.6639 14.5998 16.6056 14.7332 16.4833L15.3332 15.9Z",
    fill: "#00A7A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuther);
export default __webpack_public_path__ + "static/media/auther.fd2d636fe8a79a81d58fa9427a356ac7.svg";
export { ForwardRef as ReactComponent };